// Libs
import React, { useState } from "react";

// Components

import NewsContentSelector from "./ui/NewsContentSelector";
import NewsPostsSortingDropdown from "./ui/NewsPostsSortingDropdown";
import TextInput from "../../../../ui/TextInput";
import RadioGroup from "../../../../ui/RadioGroup";

const NewsContent = (props) => {
  const { page, isCreateMode = false } = props;

  const [enableOtherNewContent, setEnableOtherNewsContent] = useState(isCreateMode ? false : true);

  function onChangeHandler(e) {
    props.onChange({ target: { name: "meta", value: { ...props.page.meta, [e.target.name]: e.target.value } } });
  }

  function removeSelectedNewsTypeId() {
    let tempMeta = { ...props.page.meta };
    delete tempMeta?.subTypeId;
    props.onChange({ target: { name: "meta", value: tempMeta } });
  }

  function onUseExistingContentHandler() {
    props.onChange({ target: { name: "meta", value: { ...props.page.meta, name: null, subTypeId: null } } });

    if (enableOtherNewContent) {
      removeSelectedNewsTypeId();
      setEnableOtherNewsContent(false);
    } else {
      setEnableOtherNewsContent(true);
    }
  }

  return (
    <>
      <div className="line" />
      <div className="field-container">
        <p className="title">Nyhedsindhold</p>
        {isCreateMode && (
          <div className="field-wrapper">
            <label>Ønskes der at benyttes noget eksisterende nyhedsindhold?</label>
            <RadioGroup
              value={enableOtherNewContent ? 1 : 2}
              onSelect={onUseExistingContentHandler}
              className="show-at-front-page-group"
              selectedValue={enableOtherNewContent ? 1 : 2}
              options={[
                { id: 1, title: "Yes", value: true },
                { id: 2, title: "No", value: false },
              ]}
            />
          </div>
        )}

        {!enableOtherNewContent && isCreateMode && (
          <div className="field-wrapper">
            <label>Angiv navn på nyt nyhedsindhold *</label>
            <TextInput name="name" onChange={onChangeHandler} value={page?.meta?.name} />
          </div>
        )}

        {enableOtherNewContent && (
          <div className="field-wrapper">
            <label>Vælg nyhedsindhold</label>
            <NewsContentSelector
              usePlaceholder={true}
              placeholder={"Tryk for at vælge nyhedstype"}
              name="subTypeId"
              onChange={onChangeHandler}
              value={page?.meta?.subTypeId}
            />
          </div>
        )}
      </div>

      <div className="field-container">
        <p className="title">Sortering af nyhedsindlæg *</p>
        <div className="field-wrapper">
          <label>Hvordan skal nyhedsindlæg sorteres?</label>
          <NewsPostsSortingDropdown
            usePlaceholder={true}
            placeholder={"Tryk for at vælge sorteringsform"}
            name="newsPostsSortOrder"
            onChange={onChangeHandler}
            value={page?.meta?.newsPostsSortOrder ?? undefined}
          />
        </div>
      </div>
    </>
  );
};

export default NewsContent;
